<template>
  <!-- <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut" mode="out-in"> -->

  <div class="text-xs-left">
    <div>
      <img
        v-if="showProfile && answers.length > 0 && answers[0].length > 0"
        :src="'https://graph.facebook.com/' + selectedBot.pageid + '/picture?width=300&height=300'"
        alt
        style=" margin-left: 10px;width: 28px; height: 28px;border: 1px solid #eee;border-radius: 50%; float: left;margin-right: 5px;"
      />
      <div style="overflow-y: auto">
        <!-- <div v-for="(answer,index) in answers" :key="'answer_'+index"> -->
        <div
          v-for="(message, index) in answers[intent_index]"
          :key="'answer_message_' + index"
          style="margin-bottom: 5px;"
        >
          <template v-if="message.type == 'text' || message.type == 'button'">
            <template v-if="message.text == '{viewsummary}'">
              <view-cart-summary-viewer></view-cart-summary-viewer>
            </template>
            <template v-else>
              <div
                class="message"
                v-if="
                  (message.text != '' && message.type == 'text') ||
                    (message.type == 'button' && (message.buttons.length > 0 || message.text != ''))
                "
                style="position:relative;border-radius: 12px;max-width: 181px;overflow-wrap: break-word;min-height: 22px;min-width: 14px;line-height:15.36px;overflow: hidden;margin-bottom: 5px;    white-space: initial;"
                :style="{ float: align }"
              >
                <div style="font-size: 12px;" :style="{ color: color }">
                  <div style="padding: 5px 8px 6px;" :style="{ 'background-color': background }">
                    <span style="line-height:15.36px; line-height: 22px;">
                      <template v-if="message.text != ''">
                        <specialtext :text="message.text"></specialtext>
                      </template>
                      <template v-else
                        >-</template
                      >
                    </span>
                  </div>
                </div>
                <div
                  v-if="message.buttons && message.buttons.length > 0"
                  style="width: 100%;border: 1px solid #eee; border-bottom-right-radius: 12px;border-bottom-left-radius: 12px;overflow: hidden;"
                  :style="{ float: align }"
                >
                  <ul class="list-group list-group-flush" style="margin-bottom: 0px;">
                    <li
                      class="list-group-item"
                      style="border:none; border-top:1px solid #eee;border-radius: 0px;text-align: center;padding: 2px 15px"
                      v-for="(button, bindex) in message.buttons"
                      :key="bindex"
                      :style="{
                        'border-top': bindex != 0 ? '1px solid #eee' : 'none',
                        padding: !showDeep ? '10px 0' : '2px 15px'
                      }"
                    >
                      <span style="color: #0084FF">{{ button.title | truncate(20) }}</span>
                      <div style="margin: 0;font-size: 10px;" v-if="showDeep">
                        <span v-if="button.type == 'web_url'" :title="button.url">
                          {{ button.url | truncate(20) }}
                        </span>
                        <span v-else-if="button.type == 'postback'" :title="button.payload">
                          {{ button.payload | truncate(20) }}
                        </span>
                        <span v-else-if="button.type == 'phone_number'" :title="button.payload">
                          {{ button.payload | truncate(20) }}
                        </span>
                        <span v-else>&nbsp;</span>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </template>
            <div class="clearfix"></div>
          </template>
          <template v-else-if="message.type == 'image'">
            <div
              v-if="message.image_url"
              class="message"
              style="position:relative;border-radius: 12px;width: 181px;overflow-wrap: break-word;min-height: 22px;min-width: 14px;line-height:15.36px;overflow: hidden;margin-bottom: 5px;"
              :style="{ float: align }"
            >
              <div style="font-size: 12px;color:black; line-height: 0">
                <img :src="message.image_url" alt style="width: 100%" />
              </div>
            </div>
          </template>
          <template v-else-if="message.type == 'payment'">
            <div
              :style="{ float: align }"
              style="padding: 1em;text-align: left;position:relative;border-radius: 12px;width: 281px;min-height: 100px;overflow-wrap: break-word;min-height: 22px;min-width: 14px;line-height:15.36px;overflow: hidden;background-color: #EEEEEE"
            >
              <v-layout style="margin-bottom: 0px;" row>
                <vue-simple-svg
                  :filepath="'/static/img/assets/get_started/payment.svg'"
                  width="40px"
                  height="40px"
                  class="img"
                  style="
                    border-right: 2px solid #c5c5c5;
                    padding-right: 10px;
                    padding-top: 1em;
                    padding-bottom: 1em;
                    vertical-align: middle;
                    "
                />
                <v-flex style="padding-left: 1em;">
                  <div style="margin-bottom: 10px">
                    <strong>{{ $t('Detail') }}:</strong>
                    <br />
                    {{ message.data.detail }}
                  </div>
                  <div style="margin-bottom: 10px">
                    <strong>{{ $t('Amount') }}:</strong>
                    <br />
                    {{ message.data.amount }}
                  </div>
                  <div style="margin-bottom: 10px">
                    <strong>{{ $t('Delivery Method') }}:</strong>
                    <br />
                    {{ message.data.delivery.name }}
                  </div>
                  <div style="margin-bottom: 10px;">
                    <strong>{{ $t('Response Message') }}:</strong>
                    <br />
                    {{ message.data.response }}
                  </div>
                </v-flex>
              </v-layout>
            </div>
          </template>

          <template v-else-if="message.type == 'generic'">
            <generic-viewer v-model="message.data" :size="size" :align="align"></generic-viewer>
          </template>
          <template v-else-if="message.type == 'welcome_message'">
            <message-viewer v-model="welcomemessage.messages" :size="size"></message-viewer>
            <!-- <intent-getstarted v-if="welcomemessage" v-model="welcomemessage" :size="size"></intent-getstarted> -->
          </template>
          <template v-else-if="message.type == 'video'">
            <div
              class="message"
              style="min-height: 150px;border: 1px solid #eee;position:relative;border-radius: 12px;width: 181px;overflow-wrap: break-word;min-height: 22px;min-width: 14px;line-height:15.36px;overflow: hidden;"
              :style="{ float: align }"
            >
              <template v-if="message.picture">
                <v-img :src="message.picture" :aspect-ratio="16 / 9" color="grey"></v-img>
              </template>
              <template v-else>
                <v-responsive :aspect-ratio="16 / 9">
                  <div style="background: #eee; height: 100%"></div>
                </v-responsive>
              </template>

              <v-layout
                fill-height
                absolute
                class="text-xs-center"
                style="top: 0; bottom: 0; position: absolute; left: 0; right: 0"
              >
                <div
                  style="margin: auto; width: 100%"
                  :title="message.source"
                  :alt="message.source"
                >
                  <v-btn fab small depressed color="white">
                    <v-icon large>play_circle_filled</v-icon>
                  </v-btn>
                </div>
              </v-layout>
            </div>
            <div class="clearfix"></div>
          </template>
          <template v-else-if="message.type == 'responsepost'">
            <template v-if="message.replyinbox">
              <i class="fas fa-check-circle primary-color"></i>
              {{ $t('Reply to inbox') }}
              <div
                v-for="(inbox, iindex) in message.responseinbox"
                :key="'response_inbox_' + iindex"
              >
                <template v-if="inbox.type == 'text' || inbox.type == 'button'">
                  <div
                    class="message"
                    v-if="
                      (inbox.text != '' && inbox.type == 'text') ||
                        (inbox.type == 'button' && (inbox.buttons.length > 0 || inbox.text != ''))
                    "
                    style="position:relative;border-radius: 12px;max-width: 181px;overflow-wrap: break-word;min-height: 22px;min-width: 14px;line-height:15.36px;overflow: hidden;margin-bottom: 5px;    white-space: initial;"
                    :style="{ float: align }"
                  >
                    <div style="font-size: 12px;" :style="{ color: color }">
                      <div
                        style="padding: 5px 8px 6px;"
                        :style="{ 'background-color': background }"
                      >
                        <span style="line-height:15.36px; line-height: 22px;">
                          <template v-if="inbox.text != ''">
                            <specialtext :text="inbox.text"></specialtext>
                          </template>
                          <template v-else
                            >-</template
                          >
                        </span>
                      </div>
                    </div>
                    <div
                      v-if="inbox.buttons && inbox.buttons.length > 0"
                      style="width: 100%;border: 1px solid #eee; border-bottom-right-radius: 12px;border-bottom-left-radius: 12px;overflow: hidden;"
                      :style="{ float: align }"
                    >
                      <ul class="list-group list-group-flush" style="margin-bottom: 0px;">
                        <li
                          class="list-group-item"
                          style="border:none; border-top:1px solid #eee;border-radius: 0px;text-align: center;padding: 2px 15px"
                          v-for="(button, bindex) in inbox.buttons"
                          :key="bindex"
                          :style="{
                            'border-top': bindex != 0 ? '1px solid #eee' : 'none',
                            padding: !showDeep ? '10px 0' : '2px 15px'
                          }"
                        >
                          <span style="color: #0084FF">{{ button.title | truncate(20) }}</span>
                          <div style="margin: 0;font-size: 10px;" v-if="showDeep">
                            <span v-if="button.type == 'web_url'" :title="button.url">
                              {{ button.url | truncate(20) }}
                            </span>
                            <span v-else-if="button.type == 'postback'" :title="button.payload">
                              {{ button.payload | truncate(20) }}
                            </span>
                            <span
                              v-else-if="button.type == 'phone_number'"
                              :title="button.payload"
                              >{{ button.payload | truncate(20) }}</span
                            >
                            <span v-else>&nbsp;</span>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div class="clearfix"></div>
                </template>
                <template v-else-if="inbox.type == 'image'">
                  <div
                    v-if="inbox.image_url"
                    class="message"
                    style="position:relative;border-radius: 12px;width: 181px;overflow-wrap: break-word;min-height: 22px;min-width: 14px;line-height:15.36px;overflow: hidden;margin-bottom: 5px;"
                    :style="{ float: align }"
                  >
                    <div style="font-size: 12px;color:black; line-height: 0">
                      <img :src="inbox.image_url" alt style="width: 100%" />
                    </div>
                  </div>
                </template>
                <template v-else-if="inbox.type == 'generic'">
                  <generic-viewer v-model="inbox.data" :size="size"></generic-viewer>
                </template>
                <template v-else-if="inbox.type == 'welcome_message'">
                  <message-viewer v-model="welcomeinbox.messages" :size="size"></message-viewer>
                  <!-- <intent-getstarted v-if="welcomemessage" v-model="welcomemessage" :size="size"></intent-getstarted> -->
                </template>
                <template v-else-if="inbox.type == 'video'">
                  <div
                    class="message"
                    style="min-height: 150px;border: 1px solid #eee;position:relative;border-radius: 12px;width: 181px;overflow-wrap: break-word;min-height: 22px;min-width: 14px;line-height:15.36px;overflow: hidden;"
                    :style="{ float: align }"
                  >
                    <template v-if="inbox.picture">
                      <v-img :src="inbox.picture" :aspect-ratio="16 / 9" color="grey"></v-img>
                    </template>
                    <template v-else>
                      <v-responsive :aspect-ratio="16 / 9">
                        <div style="background: #eee; height: 100%"></div>
                      </v-responsive>
                    </template>

                    <v-layout
                      fill-height
                      absolute
                      class="text-xs-center"
                      style="top: 0; bottom: 0; position: absolute; left: 0; right: 0"
                    >
                      <div
                        style="margin: auto; width: 100%"
                        :title="inbox.source"
                        :alt="inbox.source"
                      >
                        <v-btn fab small depressed color="white">
                          <v-icon large>play_circle_filled</v-icon>
                        </v-btn>
                      </div>
                    </v-layout>
                  </div>
                  <div class="clearfix"></div>
                </template>
                <template v-else-if="inbox.type == 'flex'">
                  <div
                    class="text-xs-center pa-2"
                    style="border: 1px solid #eee;border-radius: 10px"
                    :style="{ float: align }"
                  >
                    <vue-simple-svg
                      :filepath="'/static/img/assets/get_started/add-menu_list.svg'"
                      width="40px"
                      height="40px"
                      class="img"
                      :fill="$vuetify.theme.primary"
                    />
                    <div class="primary--text caption">Line Flex Message</div>
                  </div>
                  <div class="clearfix"></div>
                  <!-- <div
              class="caption mt-2 warning--text"
                  >{{$t('Note: This messages will not be shown on facebook')}}</div>-->
                </template>
              </div>
              <div class="clearfix"></div>
            </template>
            <template v-if="message.replycomment && !showProfile">
              <i class="fas fa-check-circle primary-color"></i>
              {{ $t('Reply to comment') }}
              <div
                v-for="(comment, cindex) in message.responsecomment"
                :key="'response_comment_' + cindex"
              >
                <div
                  class="message"
                  v-if="comment.text != '' && comment.type == 'text'"
                  style="position:relative;border-radius: 12px;max-width: 181px;overflow-wrap: break-word;min-height: 22px;min-width: 14px;line-height:15.36px;overflow: hidden;margin-bottom: 5px;"
                  :style="{ float: align }"
                >
                  <div style="font-size: 12px;" :style="{ color: color }">
                    <div style="padding: 5px 8px 6px;" :style="{ 'background-color': background }">
                      <span style="line-height:15.36px; line-height: 22px;">
                        <template v-if="comment.text != ''">
                          <specialtext :text="comment.text"></specialtext>
                        </template>
                        <template v-else
                          >-</template
                        >
                      </span>
                    </div>
                  </div>
                </div>
                <div class="clearfix"></div>
                <div
                  v-if="comment.image_url"
                  class="message"
                  style="position:relative;border-radius: 12px;width: 181px;overflow-wrap: break-word;min-height: 22px;min-width: 14px;line-height:15.36px;overflow: hidden;margin-bottom: 5px;"
                  :style="{ float: align }"
                >
                  <div style="font-size: 12px;color:black">
                    <img :src="comment.image_url" alt style="width: 100%" />
                  </div>
                </div>
              </div>
              <div class="clearfix"></div>
            </template>
            <template v-if="message.hidecomment && !showProfile">
              <i class="fas fa-check-circle primary-color"></i>
              {{ $t('Hide comment') }}
            </template>
          </template>
          <template v-else-if="message.type == 'flex'">
            <div
              class="text-xs-center pa-2"
              style="border: 1px solid #eee;border-radius: 10px"
              :style="{ float: align }"
            >
              <vue-simple-svg
                :filepath="'/static/img/assets/get_started/add-menu_list.svg'"
                width="40px"
                height="40px"
                class="img"
                :fill="$vuetify.theme.primary"
              />
              <div class="primary--text caption">Line Flex Message</div>
            </div>
            <div class="clearfix"></div>
            <!-- <div
              class="caption mt-2 warning--text"
            >{{$t('Note: This messages will not be shown on facebook')}}</div>-->
          </template>
          <div class="clearfix"></div>
        </div>
        <!-- </div> -->
      </div>
    </div>
  </div>
  <!-- </transition> -->
</template>

<script>
import { mapGetters } from 'vuex'
import specialtext from '@/components/elements/specialtext'
import GenericViewer from '@/components/elements/GenericViewer'
import IntentGetstarted from '@/components/view/intent/IntentGetstarted'
import ViewCartSummaryViewer from '@/components/elements/ViewCartSummaryViewer'
export default {
  name: 'message-viewer',
  props: {
    value: [Object, String, Array],
    background: {
      type: String,
      default: '#F1F0F0'
    },
    color: {
      type: String,
      default: 'black'
    },
    showDeep: {
      type: Boolean,
      default: true
    },
    size: {
      default: 'big'
    },
    showProfile: {
      default: false,
      type: Boolean
    },
    align: {
      default: 'left'
    }
  },
  data: function() {
    return {
      group: this.value,
      intent_index: 0
    }
  },
  components: {
    specialtext,
    GenericViewer,
    IntentGetstarted,
    ViewCartSummaryViewer
  },
  mounted: function() {
    var vm = this
    if (vm.answers.length > 1) {
      setInterval(() => {
        if (vm.intent_index == vm.answers.length - 1) {
          vm.intent_index = 0
        } else {
          vm.intent_index++
        }
      }, 3000)
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      welcomemessage: 'welcomeMessage'
    }),
    answers: function() {
      var vm = this
      if (vm.group == null) {
        return []
      }
      var messagelist = []
      $.each(vm.value, function(index, group) {
        var newGroup = []
        $.each(group, function(mindex, message) {
          if (
            (message.type === 'text' && message.text !== '') ||
            (message.type === 'button' && (message.buttons.length > 0 || message.text !== '')) ||
            (message.type === 'image' && message.image_url !== '' && message.image_url !== null) ||
            message.type === 'welcome_message' ||
            (message.type === 'flex' && message.contents !== '') ||
            (message.type === 'payment' && message.detail !== '')
          ) {
            newGroup.push(message)
          } else if (message.type === 'generic') {
            var generics = []
            $.each(message.data, function(gindex, g) {
              if (
                g.title !== '' ||
                g.subtitle !== '' ||
                g.buttons.length > 0 ||
                (g.image_url !== '' && g.image_url != null) ||
                (typeof g.productid != 'undefined' && g.productid != null)
              ) {
                generics.push(g)
              }
            })
            if (generics.length > 0) {
              newGroup.push({
                type: 'generic',
                data: generics
              })
            }
          } else if (message.type === 'responsepost') {
            if (vm.showProfile) {
              if (
                message.replyinbox === true &&
                message.responseinbox[0].text !== '' &&
                message.responseinbox[0].text !== null
              ) {
                newGroup.push(message)
              }
            } else {
              if (
                (message.replyinbox === true &&
                  message.responseinbox[0].text !== '' &&
                  message.responseinbox[0].text !== null) ||
                (message.replycomment === true &&
                  message.responsecomment[0].text !== '' &&
                  message.responsecomment[0].text !== null) ||
                message.hidecomment === true
              ) {
                newGroup.push(message)
              }
            }
          } else if (message.type == 'video') {
            newGroup.push(message)
          }
        })
        if (newGroup.length > 0) {
          messagelist.push(newGroup)
        }
      })
      if (messagelist.length === 0) {
        messagelist = [[]]
      }
      vm.group = messagelist

      return vm.group
      // try {
      // var group_messages = vm.group.split('||')
      // $.each(group_messages,function(index, messages){
      //     var messages = messages.split('#nl')
      //     var newMessages = []
      //     $.each(messages, function(inedx, message){
      //         if (vm.isURL(message)) {
      //             newMessages.push(
      //                 {
      //                     type: 'image',
      //                     value: message
      //                 }
      //             )
      //         } else if (!isNaN(message)) {
      //             newMessages.push({
      //                 type: 'text',
      //                 value: {
      //                     text: message,
      //                     buttons: []
      //                 }
      //             })
      //         } else if(vm.isJsonParseable(message)) {
      //             newMessages.push(
      //                 {
      //                     type: 'text',
      //                     value: JSON.parse(message)
      //                 }
      //             )
      //         } else {
      //             newMessages.push(
      //                 {
      //                     type: 'text',
      //                     value: {
      //                         text: message,
      //                         buttons: []
      //                     }
      //                 }
      //             )
      //         }
      //     })
      //     group.push(newMessages)
      // })
      // } catch (error) {
      //     // console.log(vm.group)
      // }
    }
  },
  methods: {},
  watch: {
    value: function(newVal, oldVal) {
      // this.group = this.value
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/elements/MessageViewer.vue